import { Container } from "pixi.js";
import type { PresentationTaskRunner, ViewportStore } from "@slot/presentation";
import type { LocalizationService } from "@slot/game-shell";
import type { GameVisualAssets } from "../assets/GameVisualAssets";
import { BIG_WIN_MOTION, CANDY_PANEL_MOTION } from "../tuning/panelTuning";
import { BigWinView } from "../views/big-win/BigWinView";
import { FeatureFinishedView } from "../views/feature-finished/FeatureFinishedView";
import { FeatureTriggerView } from "../views/feature-trigger/FeatureTriggerView";
import { GameTransitionView } from "../views/game-transition/GameTransitionView";

/**
 * The round's panels in paint order — the free-spins trigger, the big win, the free-spins summary, the transition —
 * behind the shell's presenters. Every panel is UI chrome: its motion rides the chrome runner.
 */
export class GameModals extends Container {
  public readonly featureTriggerView: FeatureTriggerView;
  public readonly bigWinView: BigWinView;
  public readonly featureFinishedView: FeatureFinishedView;
  public readonly gameTransitionView: GameTransitionView;

  public constructor(input: { assets: GameVisualAssets; localization: LocalizationService; runner: PresentationTaskRunner; viewport: ViewportStore }) {
    super({ label: "GameModalContainer" });
    const { assets, localization, runner, viewport } = input;
    this.featureTriggerView = new FeatureTriggerView({ card: assets.textures.cardPurple, viewport, localization, runner, motion: CANDY_PANEL_MOTION });
    this.bigWinView = new BigWinView({ viewport, localization, runner, tuning: BIG_WIN_MOTION });
    this.featureFinishedView = new FeatureFinishedView({ card: assets.textures.cardPink, viewport, localization, runner, motion: CANDY_PANEL_MOTION });
    this.gameTransitionView = new GameTransitionView();
    this.addChild(this.featureTriggerView, this.bigWinView, this.featureFinishedView, this.gameTransitionView);
  }

  public dispose(): void {
    this.featureTriggerView.dispose();
    this.bigWinView.dispose();
    this.featureFinishedView.dispose();
    this.destroy({ children: true });
  }
}
